module.exports = __webpack_public_path__ + "img/logo_soroubat.e458271e.png";